/**
 * TkBankSelectionコンポーネントは、銀行選択機能を提供するReactコンポーネントです。
 * TkBankSelectionProviderを使用してコンテキストを提供し、TkBankSelectionComコンポーネントをラップします。
 * TkBankSelectionComコンポーネントは、銀行選択のステップを管理し、各ステップに対応するコンポーネントを表示します。
 */
import React, { useContext, useEffect, useState } from "react";
import FinancialInstitutionSelection from "./components/FinancialInstitutionSelection";
import { TkBankSelectionContext, TkBankSelectionProvider } from "./context";
import { IBankSelection } from "../../../type/componentsType/TkBankSelection";
import TkModal from "../../atoms/TkModal";
import "./_style.scss";
import TkStepper from "../../atoms/TkStepper";
import { steps } from "./parts";
import BranchSelection from "./components/BranchSelection";
import ConfirmationTable from "./components/ConfirmationTable";

const TkBankSelection: React.FC<IBankSelection> = (props) => {
  return (
    <TkBankSelectionProvider>
      <TkBankSelectionCom {...props} />
    </TkBankSelectionProvider>
  );
};

/**
 * TkBankSelectionComコンポーネントは、銀行選択のステップを管理し、各ステップに対応するコンポーネントを表示するReactコンポーネントです。
 * @param {IBankSelection} props - 銀行選択コンポーネントのプロパティ
 * @param {boolean} props.open - モーダルの表示状態
 * @param {Function} props.onClose - モーダルを閉じるためのコールバック関数
 * @param {Function} props.onSuccessful - 銀行選択が成功した際のコールバック関数
 */
const TkBankSelectionCom: React.FC<IBankSelection> = (props) => {
  const { open, onClose, onSuccessful } = props;

  const [stepNow, setStepNow] = useState<number>(0);

  const { state } = useContext(TkBankSelectionContext);

  useEffect(() => {
    setStepNow(state.step ?? 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.step]);

  return (
    <TkModal open={open} className="tkBankSelection">
      <TkStepper steps={steps} activeStep={stepNow}></TkStepper>

      {
        {
          0: <FinancialInstitutionSelection onClose={onClose} />,
          1: <BranchSelection />,
          2: <ConfirmationTable onSuccessful={onSuccessful} />,
        }[stepNow]
      }
    </TkModal>
  );
};

export default TkBankSelection;
